module.exports = __webpack_public_path__ + "static/img/8.44ed0be8.jpg";